import { scenarios } from "@/mocks/portal";

export default function ScenarioPicks() {
  return (
    <section id="scenario" className="scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-route-line text-sm" aria-hidden="true" />
              Scenario
            </span>
            <h2 className="mt-1 text-lg font-bold text-foreground-950 md:text-2xl">不同网络环境，怎么快速切换</h2>
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">多线选择不该一刀切，按场景匹配底线路由，比无脑追最高速更靠谱。</p>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {scenarios.map((s) => (
            <article
              key={s.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={s.cover}
                  alt={s.title}
                  title={`吃瓜线路 多线选择 ${s.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 grid h-8 w-8 place-items-center rounded-lg bg-background-50/90 text-primary-600 backdrop-blur">
                  <i className={`${s.icon} text-base`} aria-hidden="true" />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <p className="text-[11px] font-semibold text-secondary-600">{s.tip}</p>
                <h3 className="mt-1 text-sm font-bold text-foreground-950 md:text-[15px]">{s.title}</h3>
                <p className="mt-2 flex-1 text-[13px] leading-6 text-foreground-600">{s.desc}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {s.rec.map((r) => (
                    <span key={r} className="whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                      {r}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}